import React, {useEffect, useState} from 'react';
import AppContainer from "../../components/AppContainer";
import OpsText from "../../ops-library/ops-text";
import ArticlePreview from "../../components/app/ArticlePreview";
import ReactPaginate from "react-paginate";
import {MdArrowBackIosNew} from "react-icons/md";
import axios from "axios";
import opsToast from "../../ops-library/ops-toast";
import {LoadingSpinner} from "../../components/LoadingSpinner";


const Actualities = () => {

    const [articles, setArticles] = useState(null);
    const [itemOffset, setItemOffset] = useState(0);

    const onePageItems = 25;
    const endOffset = itemOffset + onePageItems;
    const currentArticles = articles?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(articles?.length / onePageItems);

    useEffect(() => {
        getAllPublishedArticles();
    }, []);

    function getAllPublishedArticles() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/articles/published`,
        };

        axios(configuration)
            .then((result) => {
                setArticles(result.data.content)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    const changePage = (page) => {
        const newOffset = (page.selected * onePageItems) % articles?.length;
        setItemOffset(newOffset);
    };

    return (
        <AppContainer
            showSlides={false}
            content={
                articles !== null ?
                    <div
                        className="window-content-container fa-flex-col align-items-center justify-content-center py-5">
                        <div
                            className="fa-flex-row w-100 justify-content-between align-items-center mb-5 mt-5 pt-5">
                            <OpsText type="title8 px-1" weight={800} color="color-1" alignment="left"
                                     content="Aktuality"/>
                            <ReactPaginate
                                previousLabel={<MdArrowBackIosNew color='var(--color-p-300)'
                                                                  className="ops-icon-sm"/>}
                                nextLabel={<MdArrowBackIosNew color='var(--color-p-300)'
                                                              className="ops-icon-sm transform-right"/>}
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageRangeDisplayed={2}
                                marginPagesDisplayed={1}
                                onPageChange={changePage}
                                pageCount={pageCount}
                                renderOnZeroPageCount={null}
                                containerClassName="pagination justify-content-center"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                activeClassName="active"
                            />
                        </div>
                        <div className="fa-flex-col desktop-80-phone-100 justify-content-center gap-4">
                            {currentArticles?.map((item, index) => (
                                <ArticlePreview article={item} key={index}/>
                            ))}
                        </div>
                    </div>
                    :
                    <div className="window-content-container pt-2 pb-5">
                        <LoadingSpinner/>
                    </div>
            }
        />
    );
};

export default Actualities;